import { isMarketplace, isSaeOnly } from 'views/utils/experiments/helpers'
import { getFeatureFlagCookie } from 'shared/utils/getFeatureFlagCookie'
import buildClientAPI from 'views/providers/clientAPI'

const MINICART_BADGE_SELECTORS = [
  '[data-clientside-hook~="Menubar__cart-badge"]',
  '[data-clientside-hook~="SmallHeader__cart-badge"]'
]

const MINICART_LINK_SELECTORS = [
  '[data-clientside-hook~="Menubar__cart-link"]',
  '[data-clientside-hook~="SmallHeader__cart-link"]'
]

/**
 * fail-save (for not found element) querying and setting of props
 *
 * @param {string} selector querySelector for the desired element
 * @param {object} props key/value pairs of props to set
 */
const selectAndSet = (selector, props) => {
  const element = document.querySelector(selector)
  if (element) {
    Object.keys(props).forEach(key => {
      element[key] = props[key]
    })
  }
}

export default async () => {
  const featureFlagCookie = getFeatureFlagCookie(document.cookie)

  if (
    featureFlagCookie &&
    (isSaeOnly(featureFlagCookie) || isMarketplace(featureFlagCookie))
  ) {
    const { cartService } = buildClientAPI()
    const miniCart = await cartService.fetchMiniCart()

    const cartQuantity = miniCart?.data?.entriesInCart || 0

    MINICART_BADGE_SELECTORS.forEach(selector => {
      selectAndSet(selector, { textContent: cartQuantity })
    })

    MINICART_LINK_SELECTORS.forEach(selector => {
      selectAndSet(selector, { href: '/new-cart/' }) // TODO: make cart link more dynamic
    })
  }
}
